import type { DealOffer, DealOfferSummary } from "@/components/marketplace/deal-offers-types";

export function dealOfferFromSummary(summary: DealOfferSummary): DealOffer {
  const formatCategory =
    summary.bestOfferFormatCategory ??
    (summary.formatKey === "all"
      ? null
      : (summary.formatKey as NonNullable<DealOffer["formatCategory"]>));

  return {
    tags: summary.tags ?? [],
    offerId: summary.bestOfferId,
    purchaseUrl: summary.bestOfferPurchaseUrl,
    providerKey: summary.providerKey,
    releaseMediaFormatSummary: summary.releaseMediaFormatSummary,
    providerDisplayName: summary.providerDisplayName,
    providerBrandKey: summary.providerBrandKey,
    providerIconUrl: summary.providerIconUrl,
    country: summary.providerCountry,
    linkType: "affiliate",
    source: "tracked",
    title: summary.bestOfferTitle,
    imageUrl: summary.bestOfferImageUrl,
    currentPrice: summary.bestOfferPrice,
    currentPriceTotal: summary.bestOfferPriceTotal,
    currentCurrency: summary.currency,
    currentPriceShipping: summary.bestOfferPriceShipping,
    currentShippingCountsTowardTotal: summary.bestOfferShippingCountsTowardTotal,
    currentPriceSource: summary.bestOfferPriceSource,
    currentPriceSourcePath: summary.bestOfferPriceSourcePath,
    currentPriceInstructionKey: summary.bestOfferPriceInstructionKey,
    shippingOriginCountry: summary.bestOfferShippingOriginCountry,
    formatCategory,
    currentAvailability: summary.bestOfferAvailability,
    currentCondition: summary.bestOfferCondition,
    dealMovement: summary.dealMovement,
    dealReferencePrice: summary.dealReferencePrice,
    dealReferenceKind: summary.dealReferenceKind,
    dealDelta: summary.dealDelta,
    dealDeltaPercent: summary.dealDeltaPercent,
    dealConfidence: summary.dealConfidence,
    lastChangeMovement: summary.lastChangeMovement,
    lastChangeReferencePrice: summary.lastChangeReferencePrice,
    lastChangeDelta: summary.lastChangeDelta,
    lastChangeDeltaPercent: summary.lastChangeDeltaPercent,
    priceHistoryMin: summary.priceHistoryMin,
    priceHistoryMax: summary.priceHistoryMax,
    priceHistoryAverage: summary.priceHistoryAverage,
    priceHistoryTypical: summary.priceHistoryTypical,
    priceHistoryObservationCount: summary.priceHistoryObservationCount,
    priceHistoryCurrency: summary.priceHistoryCurrency,
    priceIndicators: summary.priceIndicators,
    priceInsightsVisibility: summary.priceInsightsVisibility,
    priceInsightsVisible: summary.priceInsightsVisible ?? false,
    lastCheckedAt: summary.bestOfferLastCheckedAt,
    matchEntityType: "release",
    matchCatalogId: summary.bestReleaseId,
    matchedReleaseIds: [summary.bestReleaseId],
    matchKind: null,
    primaryOfferIsWorkBest: summary.primaryOfferIsWorkBest,
  };
}
